import {AppState} from '../reducer';

export const modalVisibleSelector = (state: AppState): boolean => state.modalReducer.modalVisible;
export const modalSlideIdSelector = (state: AppState): string => state.modalReducer.modalSlideId;
export const qrModalVisibleSelector = (state: AppState): boolean => state.modalReducer.isPresentationQrModalOpen;
